module.exports = __webpack_public_path__ + "static/media/grip-lines.470219df.svg";